import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy, useState } from 'react';
import { Icon } from '@/components/Icon';
import { Spinner } from '@/components/primitives/Spinner';
import { parseTelegramHtml, problemText } from './telegramHtml';
import s from '../MarkdownEditor.module.css';
import m from './MessageEditor.module.css';
// The visual editor is a big library: it loads with the first mailing, not with the panel.
const MessageVisual = lazy(() => import('./MessageVisual'));
/**
 * A mailing text: visual by default — it reads the way Telegram shows it; «HTML»
 * switches to the source. Either way the text is kept as Telegram HTML. A text the
 * visual editor would lose parts of stays in HTML until it is fixed.
 */
export function MessageEditor({ value, onChange, disabled, label, }) {
    const [mode, setMode] = useState(() => parseTelegramHtml(value).problems.length ? 'html' : 'visual');
    const [notice, setNotice] = useState(null);
    const toggle = () => {
        if (mode === 'visual') {
            setMode('html');
            return;
        }
        const problem = parseTelegramHtml(value).problems[0];
        if (problem) {
            setNotice(`Сначала поправь HTML: ${problemText(problem)}`);
            return;
        }
        setNotice(null);
        setMode('visual');
    };
    const controls = (_jsx("button", { type: "button", className: s.modeButton, "aria-pressed": mode === 'html', title: mode === 'html' ? 'Вернуться к обычному виду' : 'Показать HTML', onClick: toggle, children: "HTML" }));
    return (_jsxs("div", { className: s.shell, "data-mode": mode, children: [mode === 'visual' ? (_jsx(Suspense, { fallback: _jsx("div", { className: s.loading, children: _jsx(Spinner, { size: 16 }) }), children: _jsx(MessageVisual, { value: value, onChange: onChange, disabled: disabled, label: label, controls: controls }) })) : (_jsxs("div", { className: s.mode, children: [_jsx("div", { className: s.toolbar, children: _jsxs("div", { className: s.toolRow, children: [_jsx("span", { className: m.tags, children: "b i u s tg-spoiler a code pre blockquote" }), _jsx("div", { className: s.viewTools, children: controls })] }) }), _jsx("textarea", { className: m.source, value: value, rows: 8, disabled: disabled, spellCheck: false, "aria-label": `${label}, HTML`, onChange: (event) => {
                            setNotice(null);
                            onChange(event.target.value);
                        } })] })), notice && (_jsxs("div", { className: s.notice, role: "alert", children: [_jsx(Icon, { name: "warn", size: 14 }), _jsx("span", { children: notice }), _jsx("button", { type: "button", className: s.noticeClose, "aria-label": "\u0421\u043A\u0440\u044B\u0442\u044C", onClick: () => setNotice(null), children: _jsx(Icon, { name: "x", size: 13 }) })] }))] }));
}
